export const VALUE_PLAN_DROPDOWN = 'VALUE_PLAN_DROPDOWN';
export const CAMPAIGN_PRODUCTS = 'CAMPAIGN_PRODUCTS';
export const LOCALISATION = 'LOCALISATION';
export const SESSION_STACK_RECORDING = 'SESSION_STACK_RECORDING';
export const BUSINESS_INTELLIGENCE = 'BUSINESS_INTELLIGENCE';
export const SHOW_AVAILABLE_DATES = 'SHOW_AVAILABLE_DATES';
export const MULTI_LANGUAGE_SHOP = 'MULTI_LANGUAGE_SHOP';

export type FeatureFlag =
    | typeof VALUE_PLAN_DROPDOWN
    | typeof CAMPAIGN_PRODUCTS
    | typeof SESSION_STACK_RECORDING
    | typeof BUSINESS_INTELLIGENCE
    | typeof LOCALISATION
    | typeof SHOW_AVAILABLE_DATES
    | typeof MULTI_LANGUAGE_SHOP;

type Toggl = {
    readonly name: FeatureFlag;
    readonly enabled: boolean;
};

let togglz: Partial<Record<FeatureFlag, Toggl>> = {};

export function initTogglz(togglzData: ReadonlyArray<Toggl>) {
    togglz = {};
    togglzData.forEach(toggle => {
        togglz[toggle.name] = { ...toggle };
    });
}

export function isFeatureEnabled(featureName: FeatureFlag) {
    const toggle = togglz[featureName];
    return !!(toggle && toggle.enabled);
}

export function useFeature(feature: FeatureFlag): boolean {
    return isFeatureEnabled(feature);
}
